import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';
import { NzCalendarMode, NzCalendarModule } from 'ng-zorro-antd/calendar';
import { DateUtils } from '@shared/core';

@Component({
  selector: 'ui-calendar',
  templateUrl: './calendar.component.html',
  styleUrl: './calendar.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NzCalendarModule],
})
export class UICalendar {
  @Input() mode: NzCalendarMode = 'month';
  @Input() value?: Date;
  @Input() fullscreen = true;

  @Output() valueChange = new EventEmitter<Date>();
  @Output() modeChange = new EventEmitter<NzCalendarMode>();
  @Output() panelChange = new EventEmitter<{ date: Date; mode: NzCalendarMode }>();
  @Output() selectChange = new EventEmitter<Date>();

  @ContentChild('dateCell', { static: false }) dateCellTemplate?: TemplateRef<{ $implicit: Date }>;
  @ContentChild('dateFullCell', { static: false }) dateFullCellTemplate?: TemplateRef<{
    $implicit: Date;
  }>;
  @ContentChild('monthCell', { static: false }) monthCellTemplate?: TemplateRef<{
    $implicit: Date;
  }>;
  @ContentChild('monthFullCell', { static: false }) monthFullCellTemplate?: TemplateRef<{
    $implicit: Date;
  }>;
  @ContentChild('customHeader', { static: false }) customHeaderTemplate?: TemplateRef<unknown>;

  get displayDate(): Date {
    return this.value || new Date();
  }

  get formattedDate(): string {
    return DateUtils.formatDateToLocalString(this.displayDate);
  }

  onValueChange(date: Date): void {
    this.value = date;
    this.valueChange.emit(date);
  }

  onModeChange(mode: NzCalendarMode): void {
    this.mode = mode;
    this.modeChange.emit(mode);
  }

  onPanelChange(change: { date: Date; mode: NzCalendarMode }): void {
    this.panelChange.emit(change);
  }

  onSelectChange(date: Date): void {
    this.selectChange.emit(date);
  }
}
